export default __webpack_public_path__ + "static/media/RecyclingBackground.3c7f7d2e.png";